import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(() => ({
  layoutQueueTabsContainer: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    overflow: "hidden"
  },
  layoutQueueTabsHeader: {},
  layoutQueueTabsBody: {
    display: "contents"
  },
  layoutQueueTabsFooter: {}
}));
function LayoutQueueTabs(props) {
  const { classes } = useStyles();
  const { header, body, footer, "data-testid": dataTestId } = props;
  return /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueTabsContainer, "data-testid": dataTestId }, header ? /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueTabsHeader }, header) : null, body ? /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueTabsBody }, body) : null, footer ? /* @__PURE__ */ React.createElement(Box, { className: classes.layoutQueueTabsFooter }, footer) : null);
}
export {
  LayoutQueueTabs
};
//# sourceMappingURL=LayoutQueueTabs.js.map
